import { render, staticRenderFns } from "./StaticImageCarousel.vue?vue&type=template&id=35bde2ee&"
import script from "./StaticImageCarousel.vue?vue&type=script&lang=js&"
export * from "./StaticImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bde2ee')) {
      api.createRecord('35bde2ee', component.options)
    } else {
      api.reload('35bde2ee', component.options)
    }
    module.hot.accept("./StaticImageCarousel.vue?vue&type=template&id=35bde2ee&", function () {
      api.rerender('35bde2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FaxLTpuSJ7Ab/JS/StaticImageCarousel.vue"
export default component.exports